import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';
import { Button } from '@/components/ui/button';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';

const PaymentSuccess = () => {
  const { refresh } = useSubscription();
  const navigate = useNavigate();
  const [state, setState] = useState('activating'); // activating | active | timeout
  const attemptsRef = useRef(0);

  useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      attemptsRef.current += 1;
      const ent = await refresh();
      if (cancelled) return;
      if (ent?.is_premium) {
        setState('active');
        setTimeout(() => navigate('/'), 1800);
        return;
      }
      if (attemptsRef.current >= 8) {
        setState('timeout');
        return;
      }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [refresh, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <div className="max-w-md w-full text-center rounded-2xl border border-amber-500/30 bg-slate-900 p-10 shadow-2xl" data-testid="payment-success">
        {state === 'activating' && (
          <>
            <Loader2 className="h-14 w-14 text-amber-400 animate-spin mx-auto" />
            <h1 className="text-2xl font-bold text-white mt-6">Activating your subscription…</h1>
            <p className="text-slate-400 mt-2">Confirming your payment securely with Stripe.</p>
          </>
        )}
        {state === 'active' && (
          <>
            <CheckCircle2 className="h-14 w-14 text-emerald-400 mx-auto" />
            <h1 className="text-2xl font-bold text-white mt-6">Premium Active 🎉</h1>
            <p className="text-slate-400 mt-2">Taking you to your dashboard…</p>
          </>
        )}
        {state === 'timeout' && (
          <>
            <XCircle className="h-14 w-14 text-amber-400 mx-auto" />
            <h1 className="text-2xl font-bold text-white mt-6">Almost there</h1>
            <p className="text-slate-400 mt-2">
              Your payment is processing. This can take a moment — your access will unlock automatically.
            </p>
            <Button onClick={() => navigate('/')} className="mt-6 bg-amber-400 text-slate-900 font-bold hover:bg-amber-500">
              Go to Dashboard
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
